/* istanbul ignore file */
import React from 'react';
import SingleProjectBreadcrumbs from 'domain/projects/project/shared/SingleProjectBreadcrumbs';
import { UpdateBreadcrumbItem } from 'framework/ui/BreadCrumbs';

const UpdateProjectBreadcrumbs = () => {
  return (
    <SingleProjectBreadcrumbs>
      <UpdateBreadcrumbItem />
    </SingleProjectBreadcrumbs>
  );
};

export default UpdateProjectBreadcrumbs;
